module.exports = __webpack_public_path__ + "static/media/fundo-principal.11152b29.png";